module.exports = __webpack_public_path__ + "img/flower.f4da50e3.png";